import { render } from "./ProcesosGraduacionGrupos.vue?vue&type=template&id=e6e3ef42&scoped=true"
import script from "./ProcesosGraduacionGrupos.vue?vue&type=script&lang=js"
export * from "./ProcesosGraduacionGrupos.vue?vue&type=script&lang=js"

import "./ProcesosGraduacionGrupos.vue?vue&type=style&index=0&id=e6e3ef42&scoped=true&lang=css"

import exportComponent from "D:\\GIT\\DevOps\\Planner\\FRONT_Planner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6e3ef42"]])

export default __exports__